import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getOrgDashboardStats } from "../service/orgAdminService";
import type { OrgDashboardStats } from "../types";
import i18n from "@/i18n";

interface OrgDashboardState {
  data: OrgDashboardStats | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrgDashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchOrgDashboardStats = createAsyncThunk(
  "orgDashboard/fetchStats",
  async (organizationId: number, { rejectWithValue }) => {
    try {
      return await getOrgDashboardStats(organizationId);
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.error ?? i18n.t("orgAdmin:orgDashboardSlicetsMsgs.failedToFetchDashboardData"));
    }
  }
);

const orgDashboardSlice = createSlice({
  name: "orgDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrgDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrgDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrgDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default orgDashboardSlice.reducer;